function sessionVenteController(
  $translate,
  $state,
  $scope,
  WS,
  $window,
  $parse,
  $compile,
  $timeout,
  $uibModal
) {
  "ngInject";
  const vm = this;

  vm.form = {}
  vm.forminfo = {}
  vm.caisse = {}

  vm.current_date = moment().format('DD/MM/YYYY');


  vm.selectUsers = function () {
    WS.get('users/selectUsers', vm.access)
      .then(function (response) {
        if (response.status == 200) {
          vm.selectusers = response.data;

          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });
  };

  vm.getTotalBycolonne = function (list, type) {
    if (!list) return 0;
    var total = 0;
    for (var i = 0; i < list.length; i++) {
      total = total + Number(list[i][type]);
    }
    return total;
  }

  vm.listSessionsCaisses = function () {
    var session_code = $state.params.session_code;
    vm.form.session_code = session_code ? session_code : null;
    var caisse_code = $state.params.caisse_code;
    vm.form.caisse_code = caisse_code ? caisse_code : null;

    WS.getData('sessionVente/listSessionsCaisses', vm.form)
      .then(function (response) {
        if (response.status == 200) {
          vm.session_caisses = response.data.sessions;
          vm.caisseNonCloture = response.data.caisseNonCloture;
          vm.sessionNonCloture = response.data.sessionNonCloture;

          if (vm.form.session_code && vm.session_caisses.length > 0) {
            vm.form.date_debut = moment(vm.session_caisses[0].date).format('YYYY-MM-DD');
            vm.form.date_fin = moment(vm.session_caisses[0].date).format('YYYY-MM-DD');
            vm.form.commercial_code = vm.session_caisses[0].user_code;
          }

          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });
  };


  vm.listSessionsCaissesIndex = function () {
    var session_code = $state.params.session_code;
    vm.form.session_code = session_code ? session_code : null;
    var caisse_code = $state.params.caisse_code;
    vm.form.caisse_code = caisse_code ? caisse_code : null;

    WS.getData('sessionVente/listSessionsCaissesIndex', vm.form)
      .then(function (response) {
        if (response.status == 200) {
          vm.session_caisses = response.data.sessions;
          vm.caisseNonCloture = response.data.caisseNonCloture;
          vm.sessionNonCloture = response.data.sessionNonCloture;

          if (vm.form.session_code && vm.session_caisses.length > 0) {
            vm.form.date_debut = moment(vm.session_caisses[0].date).format('YYYY-MM-DD');
            vm.form.date_fin = moment(vm.session_caisses[0].date).format('YYYY-MM-DD');
            vm.form.commercial_code = vm.session_caisses[0].user_code;
          }

          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });
  };

  vm.listMouvements = function () {
    var session_code = $state.params.session_code;
    vm.form.session_code = session_code ? session_code : null;
    var caisse_code = $state.params.caisse_code;
    vm.form.caisse_code = caisse_code ? caisse_code : null;
    WS.getData('sessionVente/listMouvements', vm.form)
      .then(function (response) {
        if (response.status == 200) {
          vm.list_mouvements = response.data.mouvements;
          vm.list_mouvements_totals = response.data.totals;

          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });
  };


  vm.listDetailsMouvements = function () {
    var session_code = $state.params.session_code;
    vm.form.session_code = session_code ? session_code : null;
    var caisse_code = $state.params.caisse_code;
    vm.form.caisse_code = caisse_code ? caisse_code : null;
    WS.getData('sessionVente/listDetailsMouvements', vm.form)
      .then(function (response) {
        if (response.status == 200) {
          // vm.list_details_mouvements = response.data.mouvements;
          vm.list_mouvements_by_caisse = response.data.total_mouvements_by_caisse;
          vm.list_mouvements_total = response.data.total_final;

          vm.list_details_mouvements = {};
          _.each(response.data.mouvements, (mvmts, caisse_code) => {
            vm.list_details_mouvements[caisse_code] = {}
            vm.list_details_mouvements[caisse_code].details = mvmts
            vm.list_details_mouvements[caisse_code].total = vm.list_mouvements_by_caisse[caisse_code];

          })
          console.log(vm.list_details_mouvements)

          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });
  };


  vm.listDetailsMouvementsProduits = function () {
    var session_code = $state.params.session_code;
    vm.form.session_code = session_code ? session_code : null;
    var caisse_code = $state.params.caisse_code;
    vm.form.caisse_code = caisse_code ? caisse_code : null;
    WS.getData('sessionVente/listDetailsMouvementsProduits', vm.form)
      .then(function (response) {
        if (response.status == 200) {
          // vm.list_details_mouvements = response.data.mouvements;
          vm.list_mouvements_by_prod = response.data.mouvements;
          vm.list_mouvements_total_by_prod = response.data.total_final;

          vm.ecart = 0;
          vm.ecart_ca = 0;
          vm.ecart_ca_ht = 0;
          vm.list_ecart = []
          _.each(vm.list_mouvements_by_prod, (mvt, index) => {
            vm.ecart += (mvt.sum_chargement - mvt.sum_retour + mvt.sum_inventaire - mvt.sum_vente - mvt.sum_gratuite);
            vm.ecart_ca += (mvt.sum_chargement - mvt.sum_retour + mvt.sum_inventaire - mvt.sum_vente - mvt.sum_gratuite) * mvt.prix_ttc;
            vm.ecart_ca_ht += (mvt.sum_chargement - mvt.sum_retour + mvt.sum_inventaire - mvt.sum_vente - mvt.sum_gratuite) * mvt.prix_ht;
            vm.list_ecart.push({
              soussociete_code: mvt.soussociete_code,
              depot_code: mvt.depot_code,
              commercial_code: mvt.commercial_code,
              societe_code: mvt.societe_code,
              produit_code: mvt.code,
              prix_ttc: mvt.prix_ttc,
              prix_ht: mvt.prix_ht,
              ecart: mvt.sum_chargement - mvt.sum_retour + mvt.sum_inventaire - mvt.sum_vente - mvt.sum_gratuite,
              ecart_ca: vm.ecart_ca
            })
          })

          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });
  };

  vm.saveNewBlToCommercial = () => {
    if (!vm.soussociete_code) {
      swal(
        $translate.instant('Attention'),
        $translate.instant('Verifier SOussociete!!'),
        'warning'
      );
    } else {
      var data = {
        soussociete_code: vm.soussociete_code,
        commercial_code: vm.commercial.code,
        client_code: vm.clientCommercial.code,
        produits: vm.list_ecart,
        ecart_ca: vm.ecart_ca,
        ecart_ca_ht: vm.ecart_ca_ht,
        ecart: vm.ecart,
      }

      console.log(data)

      WS.post('sessionVente/saveNewBlToCommercial', data)
        .then(function (response) {
          if (response.status == 200) {

            swal(
              $translate.instant('Ajout BL'),
              $translate.instant('Action effectuée avec succès'),
              'success'
            );
            $scope.$apply();
          } else { }
        })
        .then(null, function (error) {
          console.log(error);
        });
    }

  }


  vm.list_entetes = {};
  vm.listEntetes = function () {
    var session_code = $state.params.session_code;
    vm.form.session_code = session_code ? session_code : null;
    var caisse_code = $state.params.caisse_code;
    vm.form.caisse_code = caisse_code ? caisse_code : null;

    WS.getData('sessionVente/listEntetes', vm.form)
      .then(function (response) {
        if (response.status == 200) {
          // vm.list_entetes = response.data.mouvements;

          vm.bl_lists = response.data.bl_lists;
          vm.bls = response.data.bls;
          vm.list_entetes_by_caisse = response.data.total_bl_by_caisse;
          vm.list_entetes_total = response.data.total_final;
          vm.clientCommercial = response.data.clientCommercial;
          vm.commercial = response.data.commercial;

          vm.list_entetes = {};
          _.each(response.data.bls, (bls, caisse_code) => {
            vm.list_entetes[caisse_code] = {}
            vm.list_entetes[caisse_code].details = bls
            vm.list_entetes[caisse_code].total = vm.list_entetes_by_caisse[caisse_code];

          })
          console.log(vm.list_entetes)

          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });
  };

  if ($state.params.session_code) {
    vm.listSessionsCaisses(); vm.listMouvements(); vm.listDetailsMouvements(); vm.listDetailsMouvementsProduits(); vm.listEntetes();
  }

  $scope.$watchCollection(
    "vm.list_entetes",
    function (details_bls, oldValue) {
      console.log('details_bls', details_bls)
      if (details_bls[""] && details_bls[""].total) {
        var total = details_bls[""].total;
        vm.caisse.recette = total.net_a_payer;
        vm.caisse.espece = total.espece;
        vm.caisse.cheque = total.cheque;
        vm.caisse.credit = total.credit;
        vm.caisse.virement = total.virement;
        vm.caisse.remise = total.remise;

        // calcule_ecart :
        vm.total_sum_dlc_uniq_chiffre = 0;
        var journee = Number(vm.caisse.espece || 0) +
          Number(vm.caisse.cheque || 0) +
          Number(vm.caisse.credit || 0) +
          Number(vm.caisse.creditgms || 0) +
          Number(vm.caisse.credit_collectivite || 0) +
          Number(vm.caisse.credit_collectivite_depot || 0) +
          Number(vm.caisse.depense || 0) +
          Number(vm.caisse.carburant || 0) +
          Number(vm.caisse.entretien || 0) +
          Number(vm.caisse.gratuite || 0) +
          Number(vm.caisse.versement_banque || 0) +
          Number(vm.caisse.remise || 0) +
          Number(vm.caisse.total_tarifs || 0) +
          Number(vm.caisse.echange_gms || 0)
          - Number(vm.caisse.recouvrement || 0) +
          - Number(vm.caisse.retenue || 0) +
          Number(vm.caisse.ticket || 0) +
          Number(vm.caisse.avoir || 0) +
          Number(vm.caisse.dlc || 0);

        vm.caisse.journee = journee;
        vm.caisse.ecart = Number(vm.caisse.recette) + Number(vm.total_sum_dlc_uniq_chiffre) - journee;

        if (vm.sessionNonCloture) {
          console.log("vm.sessionNonCloture", vm.sessionNonCloture)
          var sessionKey = _.findIndex(vm.session_caisses, { code: vm.sessionNonCloture.code });
          console.log("sessionKey", sessionKey)
          console.log("vm.session_caisses[sessionKey]", vm.session_caisses[sessionKey])

          if (vm.session_caisses[sessionKey]) {
            console.log('formule', vm.session_caisses[sessionKey].recette, '+ ', total.net_a_payer, "=", vm.session_caisses[sessionKey].recette + total.net_a_payer)
            vm.session_caisses[sessionKey].recette = vm.session_caisses[sessionKey].recette + total.net_a_payer;
            vm.session_caisses[sessionKey].espece = vm.session_caisses[sessionKey].espece + total.espece;
            vm.session_caisses[sessionKey].cheque = vm.session_caisses[sessionKey].cheque + total.cheque;
            vm.session_caisses[sessionKey].credit = vm.session_caisses[sessionKey].credit + total.credit;
            vm.session_caisses[sessionKey].virement = vm.session_caisses[sessionKey].virement + total.virement;
            vm.session_caisses[sessionKey].remise = vm.session_caisses[sessionKey].remise + total.remise;
            vm.session_caisses[sessionKey].journee = vm.session_caisses[sessionKey].journee + journee;
            vm.session_caisses[sessionKey].ecart = vm.session_caisses[sessionKey].ecart + vm.caisse.ecart;
          }


        }
      } else {
        //find bl non cloturé
      }

    }
  );


  $scope.$watchCollection(
    "vm.caisse",
    function (details_bls, oldValue) {

      vm.total_sum_dlc_uniq_chiffre = 0;

      var journee = Number(vm.caisse.espece || 0) +
        Number(vm.caisse.cheque || 0) +
        Number(vm.caisse.credit || 0) +
        Number(vm.caisse.creditgms || 0) +
        Number(vm.caisse.credit_collectivite || 0) +
        Number(vm.caisse.credit_collectivite_depot || 0) +
        Number(vm.caisse.depense || 0) +
        Number(vm.caisse.carburant || 0) +
        Number(vm.caisse.entretien || 0) +
        Number(vm.caisse.gratuite || 0) +
        Number(vm.caisse.versement_banque || 0) +
        Number(vm.caisse.remise || 0) +
        Number(vm.caisse.total_tarifs || 0) +
        Number(vm.caisse.echange_gms || 0)
        - Number(vm.caisse.recouvrement || 0) +
        - Number(vm.caisse.retenue || 0) +
        Number(vm.caisse.ticket || 0) +
        Number(vm.caisse.avoir || 0) +
        Number(vm.caisse.dlc || 0);

      vm.caisse.journee = journee;
      vm.caisse.ecart = Number(vm.caisse.recette) + Number(vm.total_sum_dlc_uniq_chiffre) - journee;

      // recalculate all sessions :
      angular.forEach(vm.session_caisses, (session, sessionKey) => {

        // Initialize session totals
        session.recette = 0;
        session.espece = 0;
        session.cheque = 0;
        session.ticket = 0;
        session.credit = 0;
        session.depense = 0;
        session.carburant = 0;
        session.entretien = 0;
        session.gratuite = 0;
        session.dlc = 0;
        session.avoir = 0;
        session.recouvrement = 0;
        session.remise = 0;
        session.banque = 0;
        session.versement_banque = 0;
        session.tarifs_special = 0;
        session.journee = 0;
        session.ecart = 0;

        angular.forEach(session.list_caisses, function (c) {
          session.recette += Number(c.recette || 0);
          session.espece += Number(c.espece || 0);
          session.cheque += Number(c.cheque || 0);
          session.ticket += Number(c.ticket || 0);
          session.credit += Number(c.credit || 0);
          session.depense += Number(c.depense || 0);
          session.carburant += Number(c.carburant || 0);
          session.entretien += Number(c.entretien || 0);
          session.gratuite += Number(c.gratuite || 0);
          session.dlc += Number(c.dlc || 0);
          session.avoir += Number(c.avoir || 0);
          session.recouvrement += Number(c.recouvrement || 0);
          session.remise += Number(c.remise || 0);
          session.banque += Number(c.banque || 0);
          session.versement_banque += Number(c.versement_banque || 0);
          session.tarifs_special += Number(c.tarifs_special || 0);
          session.journee += Number(c.journee || 0);
          session.ecart += Number(c.ecart || 0);
        });

        vm.session_caisses[sessionKey] = session;
      })
    }
  );

  vm.onUpdateCaisse = (sessionKey, caisseKey, caisse) => {

    // recalculate ecart caisse
    vm.total_sum_dlc_uniq_chiffre = 0;

    var journee = Number(caisse.espece || 0) +
      Number(caisse.cheque || 0) +
      Number(caisse.credit || 0) +
      Number(caisse.creditgms || 0) +
      Number(caisse.credit_collectivite || 0) +
      Number(caisse.credit_collectivite_depot || 0) +
      Number(caisse.depense || 0) +
      Number(caisse.carburant || 0) +
      Number(caisse.entretien || 0) +
      Number(caisse.gratuite || 0) +
      Number(caisse.versement_banque || 0) +
      Number(caisse.remise || 0) +
      Number(caisse.total_tarifs || 0) +
      Number(caisse.echange_gms || 0)
      - Number(caisse.recouvrement || 0) +
      - Number(caisse.retenue || 0) +
      Number(caisse.ticket || 0) +
      Number(caisse.avoir || 0) +
      Number(caisse.dlc || 0);

    vm.session_caisses[sessionKey].list_caisses[caisseKey].journee = journee;
    vm.session_caisses[sessionKey].list_caisses[caisseKey].ecart = Number(caisse.recette) + Number(vm.total_sum_dlc_uniq_chiffre) - journee;

    // recalculate session totals
    var session = vm.session_caisses[sessionKey];

    // Initialize session totals
    session.recette = 0;
    session.espece = 0;
    session.cheque = 0;
    session.ticket = 0;
    session.credit = 0;
    session.depense = 0;
    session.carburant = 0;
    session.entretien = 0;
    session.gratuite = 0;
    session.dlc = 0;
    session.avoir = 0;
    session.recouvrement = 0;
    session.remise = 0;
    session.banque = 0;
    session.versement_banque = 0;
    session.tarifs_special = 0;
    session.journee = 0;
    session.ecart = 0;

    // Sum all values from list_caisses
    angular.forEach(session.list_caisses, function (c) {
      session.recette += Number(c.recette || 0);
      session.espece += Number(c.espece || 0);
      session.cheque += Number(c.cheque || 0);
      session.ticket += Number(c.ticket || 0);
      session.credit += Number(c.credit || 0);
      session.depense += Number(c.depense || 0);
      session.carburant += Number(c.carburant || 0);
      session.entretien += Number(c.entretien || 0);
      session.gratuite += Number(c.gratuite || 0);
      session.dlc += Number(c.dlc || 0);
      session.avoir += Number(c.avoir || 0);
      session.recouvrement += Number(c.recouvrement || 0);
      session.remise += Number(c.remise || 0);
      session.banque += Number(c.banque || 0);
      session.versement_banque += Number(c.versement_banque || 0);
      session.tarifs_special += Number(c.tarifs_special || 0);
      session.journee += Number(c.journee || 0);
      session.ecart += Number(c.ecart || 0);
    });

    vm.session_caisses[sessionKey] = session;
  }
  vm.addOrUpdateCaisse = (caisse, session_caisse_code = null) => {
    caisse.commercial = vm.form.commercial_code;
    caisse.date = vm.form.date_debut;
    caisse.session_caisse_code = session_caisse_code;

    var caisse_id = caisse.caisse_code ? caisse.caisse_code : ''
    swal({
      title: $translate.instant('Caisse'),
      text: $translate.instant("voulez vous vraiment Enregistrer cette caisse! " + caisse_id),
      type: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      buttonsStyling: false
    }).then(function () {
      console.log(caisse)
      WS.post('sessionVente/addOrUpdateCaisse', caisse).then(
        function () {

          swal(
            $translate.instant('Succès'),
            $translate.instant('Caisse modifiée avec succés.'),
            'success'
          ).then(function () {
          }).catch(function () {
          });
          vm.caisse = {};
          vm.listSessionsCaisses(); vm.listMouvements(); vm.listDetailsMouvements(); vm.listDetailsMouvementsProduits(); vm.listEntetes();
        },
        function () {
          swal(
            $translate.instant('Attention!'),
            $translate.instant('Erreur de traitement des données!'),
            'warning'
          );
        }
      );
    });
  }


  vm.clotureCaisse = (sessionKey, caisseKey, caisse_code) => {

    var data = {
      commercial_code: vm.form.commercial_code,
      date_debut: vm.form.date_debut,
      date_fin: vm.form.date_fin,
      caisse_code: caisse_code
    }

    swal({
      title: $translate.instant('Cloture Caisse'),
      text: $translate.instant("voulez vous vraiment Cloturer cette caisse! " + caisse_code),
      type: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      buttonsStyling: false
    }).then(function () {
      WS.post('sessionVente/clotureCaisse', data).then(
        function (response) {

          vm.session_caisses[sessionKey].list_caisses[caisseKey].cloture = 1;
          vm.session_caisses[sessionKey].list_caisses[caisseKey].date_cloture = response.data.date_cloture;
          $scope.$apply();
          swal(
            $translate.instant('Succès'),
            $translate.instant('Caisse cloturée avec succés.'),
            'success'
          ).then(function () {
          }).catch(function () {
          });
          vm.caisse = {};
          vm.listSessionsCaisses(); vm.listMouvements(); vm.listDetailsMouvements(); vm.listDetailsMouvementsProduits(); vm.listEntetes();
        },
        function () {
          swal(
            $translate.instant('Attention!'),
            $translate.instant('Erreur de traitement des données!'),
            'warning'
          );
        }
      );
    });
  };


  vm.clotureSession = (code) => {



    swal({
      title: $translate.instant('Cloture Session'),
      text: $translate.instant("voulez vous vraiment Cloturer cette session! " + code),
      type: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      buttonsStyling: false
    }).then(function () {
      WS.post('sessionVente/clotureSession', { code }).then(
        function (response) {


          swal(
            $translate.instant('Succès'),
            $translate.instant('Session cloturée avec succés.'),
            'success'
          ).then(function () {
          }).catch(function () {
          });
          vm.caisse = {};
          $scope.$apply();
          vm.listSessionsCaisses(); vm.listMouvements(); vm.listDetailsMouvements(); vm.listDetailsMouvementsProduits(); vm.listEntetes();
        },
        function () {
          swal(
            $translate.instant('Attention!'),
            $translate.instant('Erreur de traitement des données!'),
            'warning'
          );
        }
      );
    });
  };


  vm.detailsMouvementsByNumeros = (type) => {

    var mouvements = vm.list_mouvements[type] ? vm.list_mouvements[type] : [];
    vm.numeros = _.pluck(mouvements, 'numero');
    var data = {
      commercial_code: vm.form.commercial_code,
      date_debut: vm.form.date_debut,
      date_fin: vm.form.date_fin,
      numero: vm.numeros,
      type: type,
    }

    WS.post('sessionVente/detailsMouvementsByNumeros', data)
      .then(function (response) {
        if (response.status == 200) {
          vm.mouvementsByNumero = response.data.mouvementsByNumero;
          vm.mouvementsByProd = response.data.mouvementsByProd;
          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });

  }


  vm.detailsMouvementsByProduit = (produit_code) => {

    var session_code = $state.params.session_code;

    var data = {
      commercial_code: vm.form.commercial_code,
      date_debut: vm.form.date_debut,
      date_fin: vm.form.date_fin,
      produit_code: produit_code
    }
    if (session_code) {
      data.session_code = session_code;
    }


    WS.getData('sessionVente/detailsMouvementsByProduit', data)
      .then(function (response) {
        if (response.status == 200) {
          vm.mouvementsProduit = response.data.mouvementsProduit;
          //vm.lignecommercials = response.data.lignecommercials;
          vm.totalByType = response.data.totalByType;
          vm.stock_quantite = response.data.stock_quantite;
          vm.stock_chiffre = response.data.stock_chiffre;
          console.log(vm.totalByType);
          $scope.$apply();
        } else { }
      })
      .then(null, function (error) {
        console.log(error);
      });

  }


  vm.allsocietes = {}
  vm.selectSoussocietes = function () {
    WS.get('soussocietes/selectSoussocietes').then(
      function (response) {
        vm.soussocietes = response.data;
        _.each(vm.soussocietes, element => {
          vm.allsocietes[element.code] = element;
        })

        if (vm.soussocietes.length == 1) {
          vm.soussociete_code = vm.soussocietes[0].code;
        }



        $scope.$apply();
      },
      function (error) {
        console.log(error);
      });
  };


  vm.printPanel = function (panel) {

    var mywindow = window.open('', 'PRINT');

    mywindow.document.write(`<html>
                                    <head>
                                    <title> ${document.title} </title>
                                    <style>
                                        .printonly{display:block!important;}
                                        .noprint{display: none;}.text-center{text-align:center}
                                        table {
                                            border-collapse: collapse;
                                        }
                                        th, td {
                                            border: 1px solid #ddd !important;
                                        }
                                        td.oneLine{white-space: nowrap;}
                                        .col-md-2{width:20%;float:left;}
                                        .col-md-3{width:25%;float:left;}
                                        .col-md-4{width:33%;float:left;}
                                        .col-md-8{width:66%;float:left;}
                                        .total_dist_59{background-color: #95f5c5;}
                                        .total_final_59{background-color: #d195f8;}
                                    </style>
                                `);
    mywindow.document.write('</head><body >');
    mywindow.document.write(document.getElementById(panel).innerHTML);
    mywindow.document.write('</body></html>');
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  }


  vm.findCurrentCaisseCode = (caisse) => {
    if (caisse.cloture == 1) {
      vm.current_caisse_code = caisse.caisse_code;
    } else {
      vm.current_caisse_code = "";
    }
  }

}
export default {
  name: "sessionVenteController",
  fn: sessionVenteController,
};
